import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateComponent } from '../state-component.interface';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { Subscription } from 'rxjs';

type SingleEndpointInput = {
  name: string;
  endpoint_level_uid: string;
  endpoint_sublevel_uid: string;
  study_objective_uid: string;
};
type EndpointInput = {
  all_endpoints: SingleEndpointInput[];
};


@Component({
  selector: 'app-endpoints',
  imports: [],
  templateUrl: './endpoints.component.html',
  styleUrl: './endpoints.component.css'
})
export class EndpointsComponent implements StateComponent, OnInit, OnDestroy {
  stateName = 'Endpoints';
  private usdmSub: Subscription | null = null;
  primaryEndpoints: string[] = [];
  secondaryEndpoints: string[]= [];
  data: EndpointInput | null = null;

  constructor(private usdm: Usdm2Service) { }

  ngOnInit(): void {
    this.usdmSub = this.usdm.contentUpdate$.subscribe((item) => {
      if (this.usdm.currentState() == this.stateName && item && item.type === 'FinishResponse') {
        this.data = item.result as EndpointInput;
        this.extractEndpoints();
        this.usdm.signalStateCompletion(this.stateName);
      }
    });
  }

  ngOnDestroy(): void {
    this.usdmSub?.unsubscribe();
    this.usdmSub = null;
  }

  extractEndpoints(): void {
    if (!this.data) return;

    this.primaryEndpoints = [];
    this.secondaryEndpoints = [];

    for (const endpoint of this.data.all_endpoints) {
      const uid = (endpoint?.endpoint_level_uid ?? '').toString().toLowerCase();
      const name = endpoint?.name ?? '';
      if (!name) continue;
      if (uid.endsWith('pri')) {
        this.primaryEndpoints.push(name);
      } else {
        this.secondaryEndpoints.push(name);
      }
    }
  }
}
